import React from "react";

export function Text({ as = "p", style = undefined, children = undefined, className = undefined, onClick = undefined }) {
  const Component = as;
  return (
    <Component onClick={onClick} className={className} style={style}>
      {children}
    </Component>
  );
}
